import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { Size as AvatarSize } from './enums/size.js';
export { AvatarSize };
let ViedocAvatar = class ViedocAvatar extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.src = undefined;
        this.size = AvatarSize.Medium;
        this.defaultAvatar = html `<viedoc-icon name="avatar"></viedoc-icon>`;
    }
    getInitials() {
        if (!this.name)
            return '';
        const numberOfLetter = this.size === AvatarSize.Small ? 1 : 2;
        const strs = this.name.trim().split(/\s+/).slice(0, numberOfLetter);
        return strs.map(str => str[0]).join('');
    }
    buildAvatarContent() {
        if (this.src)
            return html `<img
        .src=${this.src}
        alt=${this.name}
        class="avatar__image"
      />`;
        if (this.name)
            return html `<div class="avatar__content">${this.getInitials()}</div>`;
        return html `<div class="avatar__content">${this.defaultAvatar}</div>`;
    }
    render() {
        const classNames = classMap({
            avatar: true,
            [`avatar--${this.size}`]: true,
        });
        return html `<div title="${this.name}" class=${classNames}>
      ${this.buildAvatarContent()}
    </div>`;
    }
};
ViedocAvatar.styles = [
    css `
      :host {
        display: inline-flex;
      }

      .avatar {
        flex: 0 0 auto;
        position: relative;
        overflow: hidden;

        font-family: var(--font-family-monument);
        font-size: calc(1.75rem - 2 * 0.375rem);
        text-transform: uppercase;

        height: 1.75rem; /* 28px */
        width: 1.75rem;
      }

      .avatar,
      .avatar__image,
      .avatar__content {
        border-radius: 999px;
      }

      /* used when (image) src propery is given */
      .avatar__image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        object-fit: cover; /* keep image aspect ratio and fill the given dimension */
      }

      /* unnamed slot wrapper used when (image) src is undefined;
      the slot will probably contain viedoc-icon or user initials */
      .avatar__content {
        display: flex;
        align-items: center;
        justify-content: center;

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        color: var(--avatar-color);
        background-color: var(--avatar-background-color);
      }

      viedoc-icon {
        display: flex;
        padding: 0.375rem;
      }

      /* -- AVATAR SIZES -- */

      .avatar--small {
        height: 1.375rem; /* 22px */
        width: 1.375rem;
        font-size: calc(1.375rem - 2 * 0.313rem);
      }

      .avatar--small viedoc-icon {
        padding: 0.313rem;
      }

      .avatar--large {
        height: 2.688rem; /* 43px */
        width: 2.688rem;
        font-family: var(--font-family-viedoc);
        font-size: calc(2.688rem - 2 * 0.625rem);
      }

      .avatar--large viedoc-icon {
        padding: 0.625rem;
      }
    `,
];
__decorate([
    property({ type: String })
], ViedocAvatar.prototype, "name", void 0);
__decorate([
    property({ type: String })
], ViedocAvatar.prototype, "src", void 0);
__decorate([
    property({ type: String })
], ViedocAvatar.prototype, "size", void 0);
ViedocAvatar = __decorate([
    customElement('viedoc-avatar')
], ViedocAvatar);
export { ViedocAvatar };
